import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import * as colors from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import PersonIcon from "@material-ui/icons/Person";
import CRC from "crc-32";
import moment from "moment-timezone";
import React from "react";

import { DateTime } from "../Date";
import ImagePreviewDialog from "./../ImagePreviewDialog";

const palette = [
  colors.amber,
  colors.blue,
  colors.cyan,
  colors.deepOrange,
  colors.deepPurple,
  colors.green,
  colors.indigo,
  colors.lightBlue,
  colors.lightGreen,
  colors.lime,
  colors.orange,
  colors.pink,
  colors.purple,
  colors.red,
  colors.teal,
  colors.yellow
].map(color => color[500]);

const useStyles = makeStyles(
  theme => ({
    avatar: {
      left: -45,
      position: "absolute",
      top: 0
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)",
      display: "flex",
      justifyContent: "space-between"
    },
    date: {
      color: theme.typography.caption.color
    },
    dot: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      height: 8,
      left: -29,
      position: "absolute",
      top: 60,
      width: 8
    },
    imageIcon: {
      "&:hover": {
        border: "1px solid #e4e3e3",
        borderRadius: "5px",
        cursor: "pointer"
      }
    },
    root: {
      position: "relative"
    },
    title: {
      "& p": {
        fontSize: "14px"
      },
      alignItems: "right",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(),
      paddingLeft: theme.spacing(3)
    }
  }),
  { name: "TimelineImage" }
);

interface TimelineImageProps {
  date: string;
  message: string | null;
  user: {
    email: string;
  };
  imageSrc: string;
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("lll");
};

export const TimelineImage: React.FC<TimelineImageProps> = props => {
  const { date, user, message, imageSrc } = props;
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {user ? (
        <Avatar
          className={classes.avatar}
          style={{ background: palette[CRC.str(user.email) % palette.length] }}
        >
          <PersonIcon />
        </Avatar>
      ) : (
        <span className={classes.dot} />
      )}

      <div className={classes.title}>
        <Typography className={classes.date}>
          <Typography>
            <DateTime date={date} />
          </Typography>
          <Typography>{dateFormat(date)}</Typography>
        </Typography>
      </div>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: message.replace(/\n/g, "<br />")
            }}
          />
          <Tooltip title="Show Image">
            <ImageOutlinedIcon
              className={classes.imageIcon}
              color="primary"
              fontSize="large"
              onClick={() => setIsOpenModal(true)}
            />
          </Tooltip>
        </CardContent>
      </Card>
      <ImagePreviewDialog
        imageSrc={imageSrc}
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        caption={message}
      />
    </div>
  );
};
TimelineImage.displayName = "TimelineImage";
export default TimelineImage;
